/**
 * Hook for managing pagination state
 */

import { useState, useEffect, useCallback } from "react";

/**
 * Manage pagination state
 * @param {Array} items - Array of items to paginate
 * @param {number} defaultPerPage - Default items per page
 * @returns {Object} Pagination state and handlers
 */
export const usePagination = (items, defaultPerPage = 50) => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(defaultPerPage);

  // Reset page when items change
  useEffect(() => {
    setPage(0);
  }, [items]);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangePerPage = useCallback((event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const paginatedItems = items.slice(page * perPage, page * perPage + perPage);

  return {
    page,
    perPage,
    setPage,
    handleChangePage,
    handleChangePerPage,
    paginatedItems,
    totalCount: items.length,
  };
};
